module.exports = __webpack_public_path__ + "fix-flip-cover.1cee8b0.png";